import { morph } from '@theme/morph';
import { ThemeEvents } from '@theme/events';

/**
 * <plushee-variant-sync id="…" data-product-id="…">
 *
 * The theme only refreshes price / form / stock inside the section that holds the
 * variant picker. This element listens to the theme's own `variant:update` event on
 * the whole document and re-renders itself from the HTML the variant picker already
 * fetched (same page, new variant), using the theme's morph.
 * Used by the offer recap, the final CTA, the sticky bar and the INNOV pickers.
 */
class PlusheeVariantSync extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /** @param {Event} event */
  #handleVariantUpdate = (event) => {
    const data = /** @type {any} */ (event).detail?.data;
    if (!data?.html || !this.id) return;
    if (!data.newProduct && data.productId && data.productId !== this.dataset.productId) return;

    const next = data.html.getElementById(this.id);
    if (next) morph(this, next);
  };
}

if (!customElements.get('plushee-variant-sync')) {
  customElements.define('plushee-variant-sync', PlusheeVariantSync);
}
